import React, { ReactNode } from 'react';

import { Close } from '@mui/icons-material';
import { Box, IconButton, Modal as MuiModal, SxProps, Typography } from '@mui/material';

export interface ModalProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  title?: string;
  subtitle?: string;
  sx?: SxProps;
}

export default function Modal({ open, onClose, children, title, subtitle, sx }: ModalProps) {
  return (
    <MuiModal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minWidth: '30%',
          minHeight: '30%',
          width: 'auto',
          height: 'auto',
          maxWidth: '90%',
          maxHeight: '80%',
          bgcolor: 'common.white',
          overflow: 'auto',
          px: 3,
          py: 2,
          ...sx,
        }}
      >
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'space-between',
            mb: 1,
          }}
        >
          <Box>
            {title && <Typography variant="h6">{title}</Typography>}
            {subtitle && <Typography variant="body1">{subtitle}</Typography>}
          </Box>
          <IconButton
            sx={{
              width: 24,
              height: 24,
            }}
            onClick={onClose}
          >
            <Close />
          </IconButton>
        </Box>
        {children}
      </Box>
    </MuiModal>
  );
}
